import { Panel } from '@/pages/panel/Panel';
import '@/styles/all.scss';
import './index.css';

function SidekickApp() {
  return <Panel />;
}

export default SidekickApp;
